<template>
  <div class="cabinet-console-available-balance">
    <img class="icon" src="/assets/images/cabinet_balance.svg" alt="">
    <div class="indicator">
      <div>Available balance</div>
      <div>{{ balance }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConsoleAvailableBalance",
  props: {
    "balance": String
  }
}
</script>
